import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { ButtonV2, Link } from '@zola/zola-ui';
import cx from 'classnames';
import includes from 'lodash/includes';

import { TABLET_MAX, DESKTOP_MIN } from '../../../../lib/responsive';

import ModalFullscreen from '../../../common/zolaUI/ModalFullscreen/ModalFullscreen';
import ChecklistFilterMenuDesktop from './ChecklistFilterMenuDesktop';
import ButtonSelector from '../../../common/zolaUI/ButtonSelector/ButtonSelector';

import '../ChecklistV2.less';
import './ChecklistFilterButton.less';

class ChecklistFilterButton extends Component {
  constructor() {
    super();

    this.state = {
      expanded: false,
    };

    this.wrapperRef = React.createRef();
    this.dropdownButton = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const isClickOutside = this.wrapperRef.current && !this.wrapperRef.current.contains(event.target);

    if (isClickOutside) {
      const { expanded } = this.state;

      if (expanded) {
        this.setState({
          expanded: false,
        });
      }
    }
  };

  handleClear = () => {
    const { clearFilters } = this.props;

    clearFilters();
    this.toggleDropdown();
  };

  handleApply = () => {
    const { applyFilters } = this.props;

    applyFilters();
    this.toggleDropdown();
  };

  toggleDropdown = () => this.setState(prevState => ({ expanded: !prevState.expanded }));

  renderDropdown = () => {
    const { toggleFilter, taskFilters, filterTaskDesktop, taskFacets } = this.props;
    const { expanded } = this.state;

    if (!expanded) return null;

    return (
      <React.Fragment>
        <Media query={`(max-width: ${TABLET_MAX}px)`}>
          <div className="dropdown-options-container dropdown-options-container--mobile" role="listbox" tabIndex="-1">
            <ModalFullscreen
              headerTitle="Filter"
              className="checklist__mobileFilters"
              headerLeftContent={(
                <Link onClick={this.handleClear} className="checklist__button--cancel">
                  Clear All
                </Link>
              )}
              onClose={this.toggleDropdown}
              footerContent={(
                <ButtonV2 onClick={this.handleApply} className="mobile__button--applyFilters">
                  Apply Filters
                </ButtonV2>
              )}
            >
              <div className="dropdown-container dropdown-options--mobile">
                {taskFacets.map(facet => (
                  <React.Fragment key={facet.label}>
                    <div className="dropdown-options__header--mobile">{facet.label}</div>
                    <ul className="dropdown-container dropdown-options--mobile">
                      {facet.options.map(option => (
                        <li className="dropdown-option" key={option.value}>
                          <ButtonSelector
                            onClick={toggleFilter}
                            value={option.value}
                            active={includes(taskFilters, option.value)}
                            className="checklist__button--filterOption"
                          >
                            {option.label}
                          </ButtonSelector>
                        </li>
                      ))}
                    </ul>
                  </React.Fragment>
                ))}
              </div>
            </ModalFullscreen>
          </div>
        </Media>
        <Media query={`(min-width: ${DESKTOP_MIN}px)`}>
          <div className="dropdown-options-container dropdown-options-container--desktop" role="listbox" tabIndex="-1">
            <div className="dropdown-container">
              <ChecklistFilterMenuDesktop
                options={taskFacets}
                toggleFilter={filterTaskDesktop}
                selectedValues={taskFilters}
              />
            </div>
          </div>
        </Media>
      </React.Fragment>
    );
  };

  render() {
    const { taskFilters } = this.props;
    const { expanded } = this.state;
    const filtersActive = Boolean(taskFilters.length);

    return (
      <div ref={this.wrapperRef} className="checklist__button--filter__container">
        <ButtonSelector
          onClick={this.toggleDropdown}
          ref={this.dropdownButton}
          secondary
          className={cx('checklist__button', 'checklist__button--large', 'checklist__button--filter', {
            active: filtersActive,
            filtersOpen: expanded,
          })}
        >
          <i className="checklist__icon--filter zola-ui-icon zola-ui-icon-filter" />
          Filter
        </ButtonSelector>
        {this.renderDropdown()}
      </div>
    );
  }
}

ChecklistFilterButton.propTypes = {
  toggleFilter: PropTypes.func,
  applyFilters: PropTypes.func,
  clearFilters: PropTypes.func,
  filterTaskDesktop: PropTypes.func,
  taskFilters: PropTypes.arrayOf(PropTypes.string),
};

ChecklistFilterButton.defaultProps = {
  taskFilters: [],
};

export default ChecklistFilterButton;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistFilterButton/ChecklistFilterButton.jsx